import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleRouting } from './remote.routing';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SettingsComponent } from './settings/settings.component'
import { CreatingGameComponent } from './creating-game/creating-game.component';
import { RemoteComponent } from './remote.component';
import { SocketService } from '../shared/services/socket.service';
import { SharedModule } from '../shared/shared.module';
import { DialogGroupsSelect } from './game/dialog-groups-select/dialog-groups-select';
import { DialogResultConfirmComponent } from './game/dialog-result-confirm/dialog-result-confirm.component';
import { CardSnackComponent } from './game/game.component';
import { CanActivateRemoteGameGuard } from './game/can-activate-remote-game.guard';
import { CanActivateRemoteGameSettingsGuard } from './settings/can-activate-remote-game-settings.guard';

@NgModule({
  imports: [
    CommonModule,
    ModuleRouting,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ],
  exports: [DialogGroupsSelect, DialogResultConfirmComponent, CardSnackComponent],
  declarations: [RemoteComponent, CreatingGameComponent, SettingsComponent, DialogGroupsSelect, DialogResultConfirmComponent, CardSnackComponent],
  providers: [SocketService, CanActivateRemoteGameGuard, CanActivateRemoteGameSettingsGuard],
  entryComponents: [DialogGroupsSelect, DialogResultConfirmComponent, CardSnackComponent]
})
export class RemoteModule { }



// WEBPACK FOOTER //
// ./src/app/remote/remote.module.ts